//** Import Modules */
import axiosWithAuth from "../../../utils/axiosWithAuth";

export function requestGetNotifications() {
  return axiosWithAuth().request({
    method: "get",
    url: `${process.env.REACT_APP_BE_API_URL}/api/users/user/notifications`,
  });
}
